import { TaskObject } from 'data/v3/data-contracts';
import {
  graphQLIdFromPhotoDBID,
  graphQLIdFromVideoDBID,
} from 'helpers/graphql-utils';

type ProjectInfo = {
  nodeId: string;
  databaseId: number;
  formattedLine1: string;
  formattedLine2: string;
};

export const PROJECT_TASK_SOURCE = {
  PHOTO: 'photo',
  VIDEO: 'video',
  PROJECT: 'project',
};

export const getSourceFromTaskAssets = ({ task }: { task: TaskObject }) => {
  const images = task.images || [];
  const videos = task.videos || [];

  if (images.length) {
    return PROJECT_TASK_SOURCE.PHOTO;
  }

  if (videos.length) {
    return PROJECT_TASK_SOURCE.VIDEO;
  }
  return null;
};

// Converting v3 REST image to graphQL image for GalleryContainer component
export const convertV3ProjectTaskImagesToGraphQLAsset = ({
  assets,
  projectInfo,
}: {
  assets: TaskObject['images'];
  projectInfo: ProjectInfo;
}) => {
  return assets.map((asset) => {
    return {
      ...asset,
      __typename: 'Photo',
      id: graphQLIdFromPhotoDBID(asset.id),
      databaseId: asset.id,
      contributor: {
        ...asset.contributor,
        name: asset.contributor.fullName,
      },
      projectInfo: {
        ...projectInfo,
        id: projectInfo.nodeId,
      },
      originalUris: [
        {
          __typename: 'PhotoVariant',
          uri: asset.urlOriginal.large,
          variant: 'ORIGINAL',
        },
        {
          __typename: 'PhotoVariant',
          uri: asset.urlOriginal.medium,
          variant: 'MEDIUM',
        },
        {
          __typename: 'PhotoVariant',
          uri: asset.urlOriginal.small,
          variant: 'THUMBNAIL',
        },
      ],
    };
  });
};

// Converting v3 REST video to graphQL image for GalleryContainer component
export const convertV3ProjectTaskVideosToGraphQLAsset = ({
  assets,
  projectInfo,
}: {
  assets: TaskObject['videos'];
  projectInfo: ProjectInfo;
}) => {
  return assets.map((asset) => {
    return {
      ...asset,
      __typename: 'Video',
      id: graphQLIdFromVideoDBID(asset.id),
      databaseId: asset.id,
      contributor: {
        ...asset.contributor,
        name: asset.contributor.fullName,
      },
      projectInfo: {
        ...projectInfo,
        id: projectInfo.nodeId,
      },
      playbackUrl: asset.urlOriginal.large,
    };
  });
};
